module.exports = __webpack_public_path__ + "static/media/sort.8161c61b.svg";